import { render, staticRenderFns } from "./HeadlineBookmarks.vue?vue&type=template&id=17dc0099"
import script from "./HeadlineBookmarks.vue?vue&type=script&lang=ts"
export * from "./HeadlineBookmarks.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineBookmarks.vue?vue&type=style&index=0&id=17dc0099&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports